
export const DeleteIcon: React.FC = ({}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="54" viewBox="0 0 48 54">
            <path id="delete_FILL1_wght400_GRAD0_opsz24" d="M169-786a5.778,5.778,0,0,1-4.237-1.762A5.777,5.777,0,0,1,163-792v-39h-3v-6h15v-3h18v3h15v6h-3v39a5.778,5.778,0,0,1-1.762,4.238A5.779,5.779,0,0,1,199-786Zm6-12h6v-27h-6Zm12,0h6v-27h-6Z" transform="translate(-160 840)" fill="#005a9e" />
        </svg>
    )
}
